<template>
    
            <v-autocomplete
                v-model="value"
                :items="customers"
                dense
                clearable                
                label="Buscar cliente"
                persistent-hint
                :item-text="customText"
                item-value="id"
                @change="handleSelecteBuyer"
                :filter="customFilter"
                outlined
                hide-details
            >                
                <template v-slot:item="data">
                    <v-list-item-content>
                        <v-list-item-title v-if="data.item.type_document === 'DNI' ">{{ data.item.name }} {{ data.item.surname }}</v-list-item-title>
                        <v-list-item-title v-else>{{ data.item.name }}</v-list-item-title>
                        <v-list-item-subtitle>{{ data.item.type_document }}: {{ data.item.document }}</v-list-item-subtitle>
                  </v-list-item-content>
                </template>
            </v-autocomplete>           

</template>

<script>

import { mapActions, mapMutations, mapState } from 'vuex';

//import CreateCustomer from '../Customer/CreateCustomer'

export default {
    name: 'Buyer',
    computed: {
        ...mapState('sales', [
            'customers',
            'buyerId',
            'buyer',
            'orderId'
        ]),
    },
    data() {
        return {
            search: '',
            value: ''
        }
    },
    methods: {
        ...mapMutations('sales', [
            'setCustomers',
            'setProduct',
            'setBuyerId',
            'setBuyer',            
        ]),
        ...mapActions('sales', [
            'getCustomers',
            'selectBuyer'
        ]),
        handleSelecteBuyer(event) {
            if (event === undefined) {
                this.setBuyerId(null)
                this.setBuyer(null)
            } else {
                this.setBuyerId(event)
                this.selectBuyer()
            }
        },
        customText(item){
            let text = item.name
            if (item.type_document === 'DNI') {
                if (item.surname) {
                    text = text + ' ' + item.surname;
                }
            }
            return text
        },
        customFilter(item, queryText, itemText) {
            let textName = '';
            if (item.name) {
                textName = item.name.toLowerCase();
            }
                
            let textDocument = '';
            if (item.document) {
                textDocument = item.document.toLowerCase();             
            }
            
            let searchText = queryText.toLowerCase()

            return textName.indexOf(searchText) > -1 || textDocument.indexOf(searchText) > -1
        }
    },
    mounted() {
        this.getCustomers()
        if(this.orderId > 0) {
            this.value = this.buyerId
        } else{
            this.setBuyerId(null)
            this.setBuyer(null)
            this.value = ''
        }        
    }
}
</script>

<style>

</style>